var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"hidden md:block w-1/3 h-full border-l border-lighter px-6 py-2 overflow-y-scroll relative min-w-max"},[_c('SearchBar'),_c('TrendingForYou'),_c('WhoToFollow')],1)}
var staticRenderFns = []

export { render, staticRenderFns }